import { backofficeApi } from '.';

// Bu dosya API generator tarafından üretilmez — güvenle düzenlenebilir.
// backoffice-api/index.ts codegen ile üzerine yazıldığı için cache tag'leri
// burada enhanceEndpoints ile uygulanır.
export const backofficeApiWithTags = backofficeApi.enhanceEndpoints({
  endpoints: {
    // ---- Roles ----
    getAllPermissionRolesAsync: { providesTags: ['Roles'] },
    createRoleAsync: { invalidatesTags: ['Roles'] },
    deleteRoleAsync: { invalidatesTags: ['Roles'] },

    // ---- Role permissions ----
    getRolePermissionsByRoleNameAsync: { providesTags: ['RolePermissions'] },
    bulkUpdateRolePermissionsAsync: { invalidatesTags: ['RolePermissions'] },
  },
});
